import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Image } from '@hivebrite/design-system/Image';

import { HeaderColumn, HeaderRow, Details } from './components';

const RegistrationEventCard = ({ event }) => {
  const {
    start_date: startDate,
    timezone,
    cover_picture_medium: coverPictureMedium,
  } = event;
  const theme = useTheme();

  const day = moment(startDate).tz(timezone).date();

  return (
    <Box flexDirection="column">
      <ImageWrapper display={{ _: 'none', l: 'block' }}>
        <Image
          src={coverPictureMedium}
          alt=""
          style={{
            borderTopLeftRadius: theme.themeVariables.globalBorderRadius,
            borderTopRightRadius: theme.themeVariables.globalBorderRadius,
          }}
        />
      </ImageWrapper>
      <Box
        display={{ _: 'flex', m: 'none', l: 'flex' }}
        p={4}
        flexDirection="column"
      >
        <SmallAndLargeScreenContent {...event} day={day} />
      </Box>
      <Box display={{ _: 'none', m: 'flex', l: 'none' }} px={4} py={5}>
        <MediumScreenContent {...event} day={day} />
      </Box>
    </Box>
  );
};

RegistrationEventCard.propTypes = {
  event: PropTypes.object,
};

export default RegistrationEventCard;

const SmallAndLargeScreenContent = ({
  start_date: startDate,
  timezone,
  end_date: endDate,
  locations,
  webinar_url: webinarUrl,
  show_webinar_url: showWebinarUrl,
  day,
  title,
}) => (
  <>
    <HeaderColumn day={day} title={title} />
    <Details
      startDate={startDate}
      timezone={timezone}
      endDate={endDate}
      locations={locations}
      webinarUrl={webinarUrl}
      showWebinarUrl={showWebinarUrl}
    />
  </>
);

const MediumScreenContent = ({
  start_date: startDate,
  timezone,
  end_date: endDate,
  locations,
  webinar_url: webinarUrl,
  show_webinar_url: showWebinarUrl,
  day,
  title,
}) => (
  <>
    <Box width="50%">
      <Box maxWidth="100%" display="block" pr={3}>
        <HeaderRow
          day={day}
          title={title}
          startDate={startDate}
          endDate={endDate}
          timezone={timezone}
        />
      </Box>
    </Box>
    <Box width="50%">
      <Box maxWidth="100%" display="block" pl={3}>
        <Details
          startDate={startDate}
          timezone={timezone}
          endDate={endDate}
          locations={locations}
          webinarUrl={webinarUrl}
          showWebinarUrl={showWebinarUrl}
        />
      </Box>
    </Box>
  </>
);

const ImageWrapper = styled(Box)`
  border-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;
